import React from "react";
import SiteFooter from "../../general/components/layout/SiteFooter";
import SiteNavbar from "../../general/components/layout/SiteNavbar";
import { serviceDetails } from "../assets/serviciosDetalle";
import ProductionChannels from "../components/ProductionChannels";
import ProductionEquipment from "../components/ProductionEquipment";
import ProductionEvents from "../components/ProductionEvents";
import ProductionGallery from "../components/ProductionGallery";
import ProductionHero from "../components/ProductionHero";
import ProductionPillars from "../components/ProductionPillars";
import ProductionSectionHead from "../components/ProductionSectionHead";
import ProductionServiceList from "../components/ProductionServiceList";
import ProductionStats from "../components/ProductionStats";
import ProductionWorkflow from "../components/ProductionWorkflow";
import ServiceCta from "../components/ServiceCta";
import serviciosNavTheme from "../components/serviciosNavTheme";

const service = serviceDetails["produccion-eventos"];
const productionNavTheme = {
    ...serviciosNavTheme,
    primary: "#0891b2",
    primaryDark: "#0e7490",
    primaryLight: "#bae6fd",
    pale: "rgba(8, 145, 178, 0.08)",
};
const [
    gallery,
    pillars,
    services,
    events,
    channels,
    workflow,
    equipment,
    sectors,
] = service.sections;
const distributionItems = channels.items.filter((item) => item[1] !== "FISP TV" && item[1] !== "Newsletter");

export default function ProduccionYCoberturaDeEventos() {
    return (
        <div className="servicios servicio-detalle service-page-produccion-eventos production-detail">
            <SiteNavbar activeSection="servicios" ctaLabel="Contactar" ctaHref="#contacto" navTheme={productionNavTheme} />
            <ProductionHero service={service} />
            <ProductionStats stats={service.stats} />

            <section className="production-section production-gallery-section">
                <div className="production-inner">
                    <ProductionSectionHead section={gallery} />
                    <ProductionGallery items={gallery.items} />
                </div>
            </section>

            <section className="production-section production-soft">
                <div className="production-inner">
                    <ProductionSectionHead section={pillars} />
                    <ProductionPillars items={pillars.items} />
                </div>
            </section>

            <section className="production-section" id="produccion-servicios">
                <div className="production-inner">
                    <ProductionSectionHead section={services} />
                    <ProductionServiceList items={services.items} />
                </div>
            </section>

            <section className="production-section production-soft">
                <div className="production-inner">
                    <ProductionSectionHead section={events} />
                    <ProductionEvents items={events.items} />
                </div>
            </section>

            <section className="production-section">
                <div className="production-inner">
                    <ProductionSectionHead section={channels} />
                    <ProductionChannels items={distributionItems} />
                </div>
            </section>

            <section className="production-section production-soft">
                <div className="production-inner">
                    <ProductionSectionHead section={workflow} />
                    <ProductionWorkflow items={workflow.items} />
                </div>
            </section>

            <section className="production-section">
                <div className="production-inner">
                    <ProductionSectionHead section={equipment} />
                    <ProductionEquipment items={equipment.items} />
                </div>
            </section>

            <section className="production-section production-soft">
                <div className="production-inner">
                    <ProductionSectionHead
                        section={{
                            ...sectors,
                            text: "Trabajamos con laboratorios farmacéuticos, sociedades médicas, universidades, facultades, organismos de salud pública, clínicas, hospitales, obras sociales, prepagas, empresas de tecnología médica, startups HealthTech, fundaciones del sector y también con equipos que organizan eventos corporativos vinculados a salud.",
                        }}
                    />
                </div>
            </section>

            <ServiceCta service={service} />
            <SiteFooter/>
        </div>
    );
}
